import { TableColumn } from '@controladad/ng-base';
import {
  StatusValues,
  OrderStatusValues,
  TransactionTypeValues,
  PaymentMethodValues,
  UserTypeValues,
  CouponTypeValues,
} from '../../data';

export function cacTableStatusCol(): TableColumn<any> {
  return {
    label: 'Status',
    type: 'tag',
    items: StatusValues,
    filterable: true,
  };
}

export function cacTableOrderStatusCol(): TableColumn<any> {
  return {
    label: 'Status',
    type: 'tag',
    items: OrderStatusValues,
    dynamicClass: (value: any) => {
      const colorMap: Record<number, string> = {
        0: 'bg-gray-50 text-gray-700 border-gray-300',
        1: 'bg-amber-50 text-amber-700 border-amber-300',
        2: 'bg-green-50 text-green-700 border-green-300',
        3: 'bg-purple-50 text-purple-700 border-purple-300',
        4: 'bg-blue-50 text-blue-700 border-blue-300',
        5: 'bg-gray-50 text-gray-700 border-gray-300',
        6: 'bg-gray-50 text-gray-700 border-gray-300',
      };
      return colorMap[value] || 'bg-gray-50 text-gray-700 border-gray-300';
    },

    filterable: [
      {
        type: 'equal',
        key: 'Statuses',
        controlType: 'select',
        items: OrderStatusValues,
        multiple: true,
      },
    ],
    sortable: true,
  };
}

export function cacTableIdCol(): TableColumn<any> {
  return { label: 'ID', sortable: true, filterable: [{ type: 'equal' }] };
}

export function cacTableTransactionTypeCol(): TableColumn<any> {
  return {
    label: 'Type',
    type: 'tag',
    items: TransactionTypeValues,
    filterable: [
      {
        type: 'equal',
        key: 'Type',
        controlType: 'select',
        items: TransactionTypeValues,
        multiple: true,
      },
    ],
    sortable: true,
  };
}

export function cacTablePaymentMethodCol(): TableColumn<any> {
  return {
    label: 'Payment Method',
    type: 'tag',
    items: PaymentMethodValues,
    filterable: [
      {
        type: 'equal',
        key: 'PaymentMethod',
        controlType: 'select',
        items: PaymentMethodValues,
        multiple: true,
      },
    ],
    sortable: true,
  };
}

export function cacTableUserTypeCol(): TableColumn<any> {
  return {
    label: 'Initiated By',
    type: 'tag',
    items: UserTypeValues,
    filterable: [
      {
        type: 'equal',
        key: 'InitiatedBy',
        controlType: 'select',
        items: UserTypeValues,
        multiple: true,
      },
    ],
    sortable: true,
  };
}

export function cacTableAmountRangeCol(): TableColumn<any> {
  return {
    label: 'Amount',
    sortable: true,
    filterable: [
      { type: 'greater', key: 'AmountFrom', inputType: 'number', label: 'From' },
      { type: 'lower', key: 'AmountTo', inputType: 'number', label: 'To' },
    ],
  };
}

export function cacTableDateRangeCol(label = 'Date', sortKey?: string): TableColumn<any> {
  return {
    label,
    type: 'datetime',
    sortable: sortKey || true,
    filterable: [
      { type: 'greater', key: 'DateFrom', controlType: 'date', label: 'From' },
      { type: 'lower', key: 'DateTo', controlType: 'date', label: 'To' },
    ],
  };
}

export function cacTableIdRangeCol(): TableColumn<any> {
  return {
    label: 'ID',
    sortable: true,
    filterable: [
      { type: 'greater', key: 'IdFrom', inputType: 'number', label: 'From' },
      { type: 'lower', key: 'IdTo', inputType: 'number', label: 'To' },
    ],
  };
}

export function cacTableCouponTypeCol(): TableColumn<any> {
  return {
    label: 'Type',
    type: 'tag',
    items: CouponTypeValues,
    filterable: [
      {
        type: 'equal',
        key: 'Type',
        controlType: 'select',
        items: CouponTypeValues,
        multiple: true,
      },
    ],
    sortable: true,
  };
}
